import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "ProductDetailAttributeModalContent" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  width: "1em",
  height: "1em",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 352 512"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    d: "M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "ProductDetailAttributeModalElements" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "ProductDetailAttributeModalElement-label" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "ProductDetailAttributeModalElement-price" }, null, -1)
const _hoisted_8 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["ProductDetailAttributeModal", { 'is-active': _ctx.isOpen }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "ProductDetailAttributeModalClose",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
      }, _hoisted_3),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.values, (value, key) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["ProductDetailAttributeModalElement", { 'is-selected': _ctx.selectedElement === Number.parseInt(key) }]),
            key: key
          }, [
            (value.image)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: value.image,
                  width: "120",
                  height: "80",
                  alt: value.label
                }, null, 8, _hoisted_5))
              : (value.color)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "ProductDetailAttributeModalElement-image",
                    style: _normalizeStyle([{"width":"120px","height":"80px"}, { background: value.color }])
                  }, null, 4))
                : _createCommentVNode("", true),
            _createElementVNode("label", _hoisted_6, _toDisplayString(value.label), 1),
            _hoisted_7,
            _createElementVNode("button", {
              class: "ButtonBase ButtonBase--sm ButtonBase--ghost",
              onClick: ($event: any) => (_ctx.selectValue(key))
            }, "Zvolit", 8, _hoisted_8)
          ], 2))
        }), 128))
      ])
    ])
  ], 2))
}